"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelSpriteSymbolArea = exports.ReelSymbolStates = void 0;
const gsap_1 = require("gsap");
const Sequence_1 = require("../../../displayobject/Sequence");
const SymbolData_1 = require("./config/SymbolData");
const pixi_js_1 = require("pixi.js");
const IReelSpriteSymbol_1 = require("./IReelSpriteSymbol");
const StateHandler_1 = require("../../../utils/StateHandler");
const ReelSymbolName_1 = require("../../../reelsymbol/ReelSymbolName");
const Helper_1 = require("../../../utils/Helper");
class ReelSymbolStates extends StateHandler_1.StateHandler {
}
ReelSymbolStates.NORMAL = "normal";
ReelSymbolStates.SPIN = "spin";
ReelSymbolStates.WIN = "win";
ReelSymbolStates.STICKY = "sticky";
ReelSymbolStates.IDLE = "idle";
ReelSymbolStates.HIDE = "hide";
ReelSymbolStates.SHOW = "show";
ReelSymbolStates.REVEAL = "reveal";
ReelSymbolStates.ACTIVE = "active";
ReelSymbolStates.INACTIVE = "inactive";
ReelSymbolStates.CHANGE_SYMBOL = "change_symbol";
ReelSymbolStates.LANDING = "landing";
ReelSymbolStates.SHAKE = "shake";
ReelSymbolStates.TRANSFORM = "transform";
ReelSymbolStates.ATTENTION = "attention";
exports.ReelSymbolStates = ReelSymbolStates;
class ReelSpriteSymbolArea extends IReelSpriteSymbol_1.IReelSpriteSymbol {
    get isScatter() {
        return this._symConfig.NAME == ReelSymbolName_1.ReelSymbolName.SCATTER;
    }
    get isInactive() {
        return this.state.equal(ReelSymbolStates.INACTIVE) || !this.visible;
    }
    get isMystery() {
        return this._symConfig.NAME == ReelSymbolName_1.ReelSymbolName.MYSTERY;
    }
    get isWild() {
        return this._symConfig.NAME == ReelSymbolName_1.ReelSymbolName.WILD;
    }
    get symName() {
        return this._symConfig.NAME;
    }
    get symbolConfig() {
        return this._symConfig;
    }
    get state() {
        return this._symbolState;
    }
    get stateType() {
        return this._symbolTypeState;
    }
    get currentStateAnim() {
        return this._currentAnimation;
    }
    get posID() {
        return this._posID;
    }
    set posID(value) {
        this._posID = value;
        this._hitPosIDs[0] = this._posID;
        for (let i = 1; i < this._hitPosIDs.length; i++)
            this._hitPosIDs[i] += 1;
    }
    get hitPos() {
        return this._hitPosIDs;
    }
    set hitPos(value) {
        this._hitPosIDs = value;
    }
    get isLowValue() {
        return this.symName[0] == "L";
    }
    get isNormalSym() {
        return this.symName.length == 2;
    }
    set type(value) {
        this._symbolTypeState.set(value);
    }
    get symbolSizeY() {
        return SymbolData_1.SymbolData.DEFAULT_SYMBOL.DIM.HEIGHT;
    }
    get symbolSizeX() {
        return SymbolData_1.SymbolData.DEFAULT_SYMBOL.DIM.WIDTH;
    }
    get symbolHeight() {
        return (this.symbolSizeY * this.scale.y);
    }
    get symbolWidht() {
        return (this.symbolSizeX * this.scale.x);
    }
    constructor(ID, symName, state = ReelSymbolStates.NORMAL, type) {
        super();
        this._symbolTypeState = new StateHandler_1.StateHandler();
        this._symbolState = new ReelSymbolStates();
        this._posID = ID;
        this._hitPosIDs = [ID];
        this.type = type;
        this.state.set(state);
        this.Init();
        this.changeSymbol(symName);
    }
    Init() {
        this._bgGFX = new PIXI.Graphics();
        this._bgGFX.alpha = 0;
        this.addChild(this._bgGFX);
        this._currentAnimation = this.createSequence();
        this._oldAnimation = this.createSequence();
        this._overlaySprite = this.createSprite();
        this._attentionGFX = new PIXI.Graphics();
        this._attentionGFX.alpha = 0;
        this.addChild(this._attentionGFX);
        this._currentAnimation.alpha = 1;
    }
    addChild(...child) {
        super.addChild(...child);
        child[0].zIndex = this.children.length;
        this.sortChildren();
        return child[0];
    }
    isHitPos(id) {
        return this._hitPosIDs.indexOf(id) >= 0;
    }
    setActive(value, delay = 0, intensity = 0.3) {
        let valState = value ? ReelSymbolStates.ACTIVE : ReelSymbolStates.INACTIVE;
        if (this.state.equal(valState))
            return new gsap_1.TimelineLite();
        if (ReelSymbolStates.ACTIVE == valState && !this.state.equal(ReelSymbolStates.INACTIVE))
            return new gsap_1.TimelineLite();
        this.state.set(valState);
        const tl = new gsap_1.TimelineLite();
        tl.delay(delay);
        if (this.isNormalSym) {
            this._overlaySprite.texture = this.currentStateAnim.texture;
            let alphaFrom = value ? intensity : 0;
            let alphaTo = value ? 0 : intensity;
            this._overlaySprite.alpha = 0;
            this._overlaySprite.tint = 0X000000;
            tl.fromTo(this._overlaySprite, 0.2, { alpha: alphaFrom }, { alpha: alphaTo });
        }
        return tl;
    }
    changeSymbol(symName) {
        // Temp
        let newConfig = SymbolData_1.SymbolData.getSymbolConfig(symName);
        let dimData = SymbolData_1.SymbolData.getDimFromConfig(newConfig, this.state.state, this._symbolTypeState.state);
        if (!dimData)
            dimData = newConfig.DIM;
        if (newConfig.NAME == "")
            return;
        this._symConfig = newConfig;
        this.scale = dimData.SCALE ? dimData.SCALE : new pixi_js_1.Point(1, 1);
        if (this._ReelFakeSymbol)
            this._ReelFakeSymbol && this._ReelFakeSymbol.changeColor(this.symName);
        const TEXTURES = SymbolData_1.SymbolData.getTextureFromConfig(this._symConfig, this.state.state, this._symbolTypeState.state);
        if (TEXTURES) {
            this._currentAnimation.setTexture(TEXTURES);
            this._currentAnimation.alpha = 1;
            this._currentAnimation.visible = true;
        }
    }
    showOverridedDisplayElement(obj) {
        if (this._diplayOverrideObj == undefined) {
            this._diplayOverrideObj = obj;
            this.addChild(this._diplayOverrideObj);
        }
        this._diplayOverrideObj = obj;
        this._diplayOverrideObj.visible = true;
        this._diplayOverrideObj.position.set(0, 0);
        this._bgGFX.visible = false;
        this._currentAnimation.visible = false;
        this._oldAnimation.visible = false;
    }
    remove() {
        this.children.forEach(child => { child.destroy(); });
        this.removeChildren();
    }
    createSprite() {
        const sp = Helper_1.Helper.createSprite();
        this.addChild(sp);
        return sp;
    }
    createSequence() {
        const sequence = Sequence_1.Sequence.createSequence();
        this.addChild(sequence);
        return sequence;
    }
}
exports.ReelSpriteSymbolArea = ReelSpriteSymbolArea;
//# sourceMappingURL=ReelSpriteSymbolArea.js.map